export const state = {
  insurers: null,
  packages: null,
  accessTypes: {
    READ: 1,
    WRITE: 2
  },
  infoTypes: {
    APPOINTMENTS: 100
  },
  appointmentFileTypes: {
    RESULT_FILE: 1,
    PATIENT_FILE: 2
  },
  paymentMethods: {
    MB: {
      id: 1,
      slug: 'mb',
      name: 'MB'
    },
    MBW: {
      id: 2,
      slug: 'mbw',
      name: 'MB Way'
    },
    CC: {
      id: 3,
      slug: 'cc',
      name: 'Credit Card'
    },
    PP: {
      id: 4,
      slug: 'pp',
      name: 'Paypal'
    },
    CASH: {
      id: 5,
      slug: 'cash',
      name: 'Cash'
    },
    OTHER: {
      id: 99,
      slug: 'other',
      name: 'Other'
    }
  },
  paymentStatuses: {
    PENDING: {
      id: 1,
      slug: 'pending',
      name: 'Pending'
    },
    PAID: {
      id: 2,
      slug: 'paid',
      name: 'Paid'
    },
    SUCCESS: {
      id: 3,
      slug: 'success',
      name: 'Success'
    },
    CAPTURE_SUCCESS: {
      id: 4,
      slug: 'capture_success',
      name: 'Capture success'
    },
    DECLINED: {
      id: 5,
      slug: 'declined',
      name: 'Declined'
    },
    CAPTURE_FAILED: {
      id: 6,
      slug: 'capture_failed',
      name: 'Capture failed'
    },
    AUTHORIZATION_SUCCESS: {
      id: 7,
      slug: 'authorisation_success',
      name: 'Authorization success'
    },
    AUTHORIZATION_FAILED: {
      id: 8,
      slug: 'authorisation_failed',
      name: 'Authorization failed'
    }
  },
  paymentTypes: {
    IN_APP: {
      id: 1,
      slug: 'in_app',
      name: 'In app payment'
    },
    IN_FACILITY: {
      id: 2,
      slug: 'in_facility',
      name: 'In facility payment'
    }
  }
}
